import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import MainButton from '@configuratorware/configurator-frontendgui/Shared/Components/MainButton';
import { T } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { fetchConfiguration } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { withGlobalLoader } from '@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions';
import getImageUrl from '@configuratorware/configurator-frontendgui/App/Utils/getImageUrl';
import { gray } from '../Colors';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: gray,
    },
    image: {
      display: 'flex',
      margin: 'auto',
      aspectRatio: 1,
      width: '100%',
      maxHeight: '80vh',
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
      },
    },
    progress: {
      margin: 'auto',
      width: '70%',
      height: '170px',
    },
    container: {
      padding: 32,
      [theme.breakpoints.down('sm')]: {
        padding: 16,
      },
    },
    title: {
      wordWrap: 'break-word',
      margin: 'auto',
      height: '30%',
      width: '100%',
      color: 'white',
      fontWeight: 'bold',
    },
    buttonContainer: {
      marginTop: 32,
      marginLeft: 'auto',
      width: 150,
      [theme.breakpoints.down('sm')]: {
        marginTop: 16,
      },
    },
  }),
  { name: 'ItemTile' }
);

const ItemTile = ({ title, linkTo, image }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const currentItemIdentifier = useSelector(state => state.configurator.configuration.item.identifier);
  const history = useHistory();
  const [loadState, setLoadState] = useState(true);

  const handleClick = async (link) => {
    try {
      if (currentItemIdentifier === linkTo) {
        // reload only if it is the same item, otherwise it is done by the core
        await dispatch(withGlobalLoader(fetchConfiguration(linkTo)));
      }
      history.push(link);
    } catch (e) {
      alert(`could not load configuration: ${linkTo}`);
    }
  };

  return (
    <div className={classes.root}>
      {loadState && <CircularProgress className={classes.progress} />}
      <div className={classes.image}>
        <img
          src={getImageUrl(image)}
          alt={title}
          onLoad={() => setLoadState(false)}
          onError={() => setLoadState(false)}
        />
      </div>
      <div className={classes.container}>
        <Typography variant="h6" className={classes.title}>
          {title}
        </Typography>
        <div className={classes.buttonContainer}>
          <MainButton fullWidth onClick={() => handleClick(`/identifier:${linkTo}`)}>
            {T('itemOverview.customize')}
          </MainButton>
        </div>
      </div>
    </div>
  );
};

ItemTile.defaultProps = {
  title: '',
  linkTo: '',
  image: '',
};

ItemTile.propTypes = {
  title: PropTypes.string,
  linkTo: PropTypes.string,
  image: PropTypes.string,
};

export default ItemTile;
